module.exports = __webpack_public_path__ + "img/coreicon1.bb1b0fef.png";